import { getEnvs } from '@/shared/utils';
const { VITE_BUCKET_BASE } = getEnvs();
import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTER_PATHS, hasAllPermissions, hasPermission, plantillaExcelENUM, useCheckPermissions, useTableFilter, useTableServerSideFiltering, useUploadFile } from "@/shared";
import { useFetchNodos, useUpdateNaps } from "@/shared/actions/erp";
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from "@/shared/components/ui";
import { Nodo } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
import { useUiConfirmModalStore } from "@/store/ui";

const returnUrl = ROUTER_PATHS.mantenimientoOperaciones.nodosNav;

export interface NodoPageInterface { }

const NodoPage: React.FC<NodoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_nodo)
  const navigate = useNavigate();
  const updSate = useUpdateNaps({
    enableRedirect: false,
  });
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    cleanFilter,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { 
    filterObject, 
    columnFilters, 
    setColumnFilters 
  } = useTableServerSideFiltering();
  const { pageIndex, pageSize } = pagination;
  ///* fetch data
  const {
    data: NodoPagingRes,
    isLoading,
    isRefetching,
  } = useFetchNodos({
    page: pageIndex + 1,
    page_size: pageSize,
    nombre: searchTerm,
    filterByState: false,
    ...filterObject,
  });
  ///* handlers
  const onEdit = (original: Nodo) => {
    navigate(`${returnUrl}/editar/${original.id_nodo}`);
  };
  ///* columns
  const columns = useMemo<MRT_ColumnDef<Nodo>[]>(
    () => [
      // {
      //   accessorKey: 'numero_referencia',
      //   header: 'numero referencia',
      //   size: 200,
      //   enableColumnFilter: false,
      // },
      /* {
        accessorKey: 'codigo',
        header: 'codigo',
        size: 200,
      }, */

      {
        accessorKey: 'nombre',
        header: 'nombre',
        size: 200,
      },
      {
        accessorKey: 'direccion',
        header: 'direccion',
        size: 300,
        enableColumnFilter: false,
      },
      {
        accessorKey: 'coordenadas',
        header: 'coordenadas',
        size: 200,
        enableColumnFilter: false,
      },
      {
        accessorKey: 'zona_data.nombre',
        header: 'zona',
        size: 200,
        enableColumnFilter: false,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_nodo)) return;
                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de este nodo ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_nodo!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      }
    ],
    []
  );


  const {
    fileInputRef,
    handleImportarExcelNodo
  } = useUploadFile();


  return (
    <SingleTableBoxScene title="Nodos"
      urlRedirect={`${returnUrl}/crear`}
      enableRedirect={hasPermission(PermissionsEnum.api_add_nodo)}
      enableUploadFile={true}
      fileInputRef={fileInputRef}
      handleFileUpload={handleImportarExcelNodo}
      urlDownloadPlantilla={"/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_NODO}
      urlDownloadNameExcel="plantilla_nodo"
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="Nodo"
        cleanFilter={cleanFilter}
      />

      <GeneralTable<Nodo>
        columns={columns}
        data={NodoPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={NodoPagingRes?.data?.count}
        // // actions
        actionsColumnSize={120}
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_nodo,
        ])}
        // crud
        onEdit={onEdit}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_nodo,
        ])}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};
export default NodoPage;
